import { actionNameGenerator } from '../../../../utils/commonUtil';

const domainPrefix = 'go';
const goActions = actionNameGenerator(domainPrefix);

export const dashboardDataFetchType = goActions('dashboardDataFetch');

export const fetchLazyLoadDataType = goActions('fetchLazyLoadData');

export const storeChartGrantsDataType = goActions('storeChartGrantsData');

export const disableGrantsShowType = goActions('disableGrantsShow');

export const resetGrantDataType = goActions('resetGrantData');

export const currentPendingGrantsSuccessType = goActions(
  'currentPendingGrantsSuccess'
);

export const currentPendingGrantsFailedType = goActions(
  'currentPendingGrantsFailed'
);

export const issuedGrantsSuccessType = goActions('issuedGrantsSuccess');

export const issuedGrantsFailedType = goActions('issuedGrantsFailed');

export const lazyLoadDataLoaderType = goActions('lazyLoadDataLoader');

export const lazyLoadPendingGrantsDataSuccessType = goActions(
  'lazyLoadPendingGrantsDataSuccess'
);

export const lazyLoadPendingGrantsDataFailedType = goActions(
  'lazyLoadPendingGrantsDataFailed'
);

export const lazyLoadIssuedDataSuccessType = goActions(
  'lazyLoadIssuedDataSuccess'
);

export const lazyLoadIssuedDataFailedType = goActions(
  'lazyLoadIssuedDataFailed'
);

export const grantsDashboardDataSuccessType = goActions(
  'grantsDashboardDataSuccess'
);

export const allGrantsDashboardDataLoadingType = goActions(
  'allGrantsDashboardDataLoading'
);

export const allGrantsDashboardDataSuccessType = goActions(
  'allGrantsDashboardDataSuccess'
);

export const allGrantsDashboardDataFailedType = goActions(
  'allGrantsDashboardDataFailed'
);

export const grantsDashboardDataLoadingType = goActions(
  'grantsDashboardDataLoading'
);

export const grantsDashboardDataFailedType = goActions(
  'grantsDashboardDataFailed'
);

export const grantsAccountDataFetchLoadingType = goActions(
  'grantsAccountDataFetchLoading'
);

export const grantsAccountDataSuccessType = goActions(
  'grantsAccountDataSuccess'
);

export const grantsAccountDataFailedType = goActions('grantsAccountDataFailed');

export const countDataFetchLoadingType = goActions('countDataFetchLoading');

export const countDataSuccessType = goActions('countDataSuccess');

export const countDataFailureType = goActions('countDataFailure');

export const storeGrantChartDataLoadingType = goActions(
  'storeGrantChartDataLoading'
);

export const storeGrantChartDataSuccessType = goActions(
  'storeGrantChartDataSuccess'
);

export const storeGrantChartDataFailedType = goActions(
  'storeGrantChartDataFailed'
);

export const resetDataGrantType = goActions('resetDataGrant');

export const currentPendingGrantsLoaderType = goActions(
  'currentPendingGrantsLoader'
);

export const issuedGrantsLoaderType = goActions('issuedGrantsLoader');

export const postCharitySearchType = goActions('postCharitySearch');

export const postCitySerachType = goActions('postCitySerach');

export const postCountySearchType = goActions('postCountySearch');

export const cityLoaderType = goActions('cityLoader');

export const countyLoaderType = goActions('countyLoader');

export const fetchSelectedAccountType = goActions('fetchSelectedAccount');

export const selectCharityType = goActions('selectCharity');

export const makeScheduleAllocationType = goActions('makeScheduleAllocation');

export const saveCharityType = goActions('saveCharity');

export const fetchPendGrantType = goActions('fetchPendGrant');

export const geminiFilterType = goActions('geminiFilter');

export const updateFromCounterType = goActions('updateFromCounter');

export const updateFromLoadingCounterType = goActions('updateFromLoadingCounter');

export const updateFromType = goActions('updateFrom');

export const einDataType = goActions('einData');

export const geminiEinDataType = goActions('geminiEinData');

export const searchTermType = goActions('searchTerm');

export const geminiSearchTermType = goActions('geminiSearchTerm');

export const searchGeminiType = goActions('searchGemini');

export const removeCharityType = goActions('removeCharity');

export const fetchSavedCharityType = goActions('fetchSavedCharity');

export const postGeminiSavedDataType = goActions('postGeminiSavedData');

export const addCharityType = goActions('addCharity');

export const cancelSaveCharityType = goActions('cancelSaveCharity');

export const clearAllFiltersType = goActions('clearAllFilters');

export const clearAllGeminiFiltersType = goActions('clearAllGeminiFilters');

export const accountSelectedDataLoaderType = goActions('accountSelectedDataLoader');

export const accountSelectedDataSuccessType = goActions(
  'accountSelectedDataSuccess'
);

export const accountSelectedDataFailedType = goActions('accountSelectedDataFailed');

export const searchCharityResponseType = goActions('searchCharityResponse');

export const searchCharityErrorResponseType = goActions(
  'searchCharityErrorResponse'
);

export const searchGeminiResponseType = goActions('searchGeminiResponse');

export const searchGeminiErrorType = goActions('searchGeminiError');

export const searchCityResponseType = goActions('searchCityResponse');

export const searchCityErrorType = goActions('searchCityError');

export const searchCountySuccessResponseType = goActions(
  'searchCountySuccessResponse'
);

export const searchCountyErrResponseType = goActions('searchCountyErrResponse');

export const updateFromCounterWorkerType = goActions('updateFromCounterWorker');

export const updateFromLoadMoreCounterWorkerType = goActions(
  'updateFromLoadMoreCounterWorker'
);

export const removeCharitySuccessType = goActions('removeCharitySuccess');

export const removeCharityFailType = goActions('removeCharityFail');

export const fetchSavedCharitySuccessType = goActions('fetchSavedCharitySuccess');

export const resetSavedCharityFlagType = goActions('resetSavedCharityFlag');

export const saveCharitySuccessType = goActions('saveCharitySuccess');

export const saveCharityFailType = goActions('saveCharityFail');

export const submitSavedGeminiDataSuccessType = goActions(
  'submitSavedGeminiDataSuccess'
);

export const submitSavedGeminiDataFailType = goActions('submitSavedGeminiDataFail');

export const addCharitySuccessType = goActions('addCharitySuccess');

export const addCharityFailType = goActions('addCharityFail');

export const fetchPendGrantSuccessType = goActions('fetchPendGrantSuccess');

export const fetchPendGrantFailType = goActions('fetchPendGrantFail');
